import React from 'react'

import { BodyText, BagIcon } from '@pb/components'
import cn from 'classnames'
import PropTypes from 'prop-types'

import styles from './HubPurchasesSingleMessage.scss'

const HubPurchasesSingleMessage: React.FC<any> = ({ className, children, shouldHaveIcon }) => {
  return (
    <div className={styles.container}>
      {shouldHaveIcon && <BagIcon className={styles.icon} />}
      <BodyText className={cn(className, styles.metaTextColor)}>{children}</BodyText>
    </div>
  )
}

HubPurchasesSingleMessage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  shouldHaveIcon: PropTypes.bool,
}

export default HubPurchasesSingleMessage
